import getTrafficEstimation from '@bingads-webui-campaign-legacy/budget/shared/getTrafficEstimation';
const endpoint = '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.CampaignTrafficEstimateWithSuggestedBid';

export default function (params, callbacks, options, timestamp) {
  return getTrafficEstimation(params, callbacks, options, endpoint, timestamp);
}
